var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaulaUserIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "#191918",
  rx: 18
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0",
  opacity: 0.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.648 25.875c-1.427-2.468-3.628-4.238-6.195-5.078a6.75 6.75 0 1 0-6.906 0c-2.568.839-4.768 2.609-6.196 5.078a.75.75 0 1 0 1.298.75c1.767-3.052 4.889-4.875 8.35-4.875 3.463 0 6.585 1.823 8.351 4.875a.75.75 0 1 0 1.298-.75M12.75 15A5.25 5.25 0 1 1 18 20.25 5.256 5.256 0 0 1 12.75 15"
})));
export { SvgPaulaUserIcon as ReactComponent };
export default __webpack_public_path__ + "cca0dc0a45083e48809bb04686caede7.svg";